export default __webpack_public_path__ + "static/media/weather.20863ddf.jpg";